import React from 'react';
import { Combo } from 'fw/forms';
import * as API from 'modules/app/API'

class CommentTypeCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    componentDidMount = () => {
		this._isMounted = true;

        API.Admin.get('/comment/getCommentTypes', {},
        {
            success: (r) => {
                this._isMounted && this.setState({
                    items: r.data.items.map((item) => { return { label: item.description, value: item.commentTypeCode } })
                });
            }
        }, { block: false });
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

    render() {
        return (
            <Combo
                {...this.props}
                items={this.state.items}
                placeholder="Select Comment Type"
                searchable={true} />
        )
    }
}

export default CommentTypeCombo;

// Mark this as a form component
CommentTypeCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/commentTypeCombo/CommentTypeCombo.js